module.exports = __webpack_public_path__ + "static/media/jeremiah.d745738f.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/jeremiah.png
// module id = 1284
// module chunks = 0